<template>
  <div class="container">
    <el-card>
      <el-row style="height:40px;">
        <el-col :span="20">
          <el-form :inline="true" :model="searchParams">
            <el-form-item>
              <el-select v-model="searchParams.status" size="small" placeholder="请选择事件状态" clearable style="width:150px">
                <el-option v-for="item of eventStatusOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input placeholder="请输入关键字" type="text" size="small" v-model="searchParams.name" clearable
                style="width: 150px">
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-input placeholder="请输入版本号" type="text" size="small" v-model="searchParams.version" clearable
                style="width: 150px">
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-select v-model="searchParams.developed_by" size="small" placeholder="选择开发人员" clearable filterable
                style="width:150px">
                <el-option v-for="user of users" :key="user.realname" :label="user.realname" :value="user.realname">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="由我创建" prop="created_by_me">
              <el-switch v-model="searchParams.created_by_me"></el-switch>
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" icon="el-icon-search" @click="page = 1; search()">
                搜索
              </el-button>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="4" style="text-align: center">
          <el-button size="small" type="primary" @click="handleAdd" style="">新增事件</el-button>
        </el-col>
      </el-row>
    </el-card>
    <el-card style="margin-top:10px">
      <el-table :data="tableData" style="margin-top: 20px" :cell-style='{ "font-size": "13px" }'>
        <el-table-column prop="pictures" label="图示" width="90" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.picList.length == 0"></span>
            <el-image v-if="scope.row.picList.length > 0" :src="scope.row.picList[0]"
              :preview-src-list="scope.row.picList" fit="contain" style="height: 40px;">
            </el-image>
            <span v-if="scope.row.picList.length > 1"> x {{ scope.row.picList.length }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="event" label="事件" width="150"></el-table-column>
        <el-table-column prop="name" label="事件名称" width="150"></el-table-column>
        <el-table-column prop="first_version" label="新增版本" width="50"></el-table-column>
        <el-table-column prop="last_version" label="最近修改" width="50"></el-table-column>
        <el-table-column prop="url" label="打点页面" width="100"></el-table-column>
        <el-table-column prop="typeName" label="打点方式" width="60"></el-table-column>
        <el-table-column prop="keys" label="补充参数" width="280">
          <template slot-scope="scope">
            <div v-for="(v, k) in scope.row.properties" :key="k">
              <!--el-tooltip :content="v.value" placement="top" :key="k"-->
              <span class="text-small">{{ v.app_version }}<el-divider direction="vertical"></el-divider><b>{{ v.key
                  }}</b>: {{ v.value }}</span>
              <!--/el-tooltip-->
              </br>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="tag" label="标签" width="200"></el-table-column>
        <el-table-column prop="disabled" label="事件状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="(eventStatusMap[scope.row.status] || { class: 'danger' }).class" disable-transitions
              size="small">{{ (eventStatusMap[scope.row.status] || { label: '未知' }).label }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="developed_by" label="开发人员" width="90"></el-table-column>
        <el-table-column prop="created_by" label="创建人员" width="90"></el-table-column>
        <!--el-table-column prop="created_at" label="创建时间"></el-table-column-->
        <el-table-column prop="update_date" label="更新日期" width="90"></el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button @click="handleEdit(scope.row)" type="text" size="small">修改</el-button>
            <el-button @click="handleDelete(scope.row)" type="text" size="small" style="color: red;">删除</el-button>
            <!--el-button type="text" size="small" @click="handleDisable(scope.row)">
              {{ scope.row.disabled ? '启用': '禁用' }}
            </el-button-->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination v-if="tableData.length > 0" layout="prev, pager, next" :total="totalCount" :page-size="limit"
        style="float: right" @current-change="changePage">
      </el-pagination>
    </el-card>
    <el-dialog :title="dialogTitle" :visible.sync="newEventDialogVisible" width="60%" :before-close="handleClose">
      <el-form ref="newEventForm" :rules="eventFormRules" :model="eventForm" label-width="80px">
        <el-form-item label="事件" prop="event">
          <el-input v-model="eventForm.event"></el-input>
        </el-form-item>
        <el-form-item label="事件名称" prop="name">
          <el-input v-model="eventForm.name"></el-input>
        </el-form-item>
        <el-form-item label="App版本" prop="app_version">
          <el-input v-model="eventForm.app_version"></el-input>
        </el-form-item>
        <el-form-item label="打点页面" prop="url">
          <el-input v-model="eventForm.url"></el-input>
        </el-form-item>
        <el-form-item label="打点方式" prop="type">
          <el-select v-model="eventForm.type">
            <el-option v-for="item of typeOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="事件状态" prop="status">
          <el-select v-model="eventForm.status">
            <el-option v-for="item of eventStatusOptions"
              :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="标签">
          <el-input v-model="eventForm.tag"></el-input>
        </el-form-item>
        <el-form-item label="补充参数">
          <el-row v-for="(ext, idx) in eventForm.extra" :key="idx" style="margin-bottom: 10px">
            <el-col :span="6">
              <el-input v-model="ext.key" placeholder="Key" size="small"></el-input>
            </el-col>
            <el-col :span="10" :offset="1">
              <el-input v-model="ext.value" placeholder="描述信息" size="small"></el-input>
            </el-col>
            <el-col :span="3" :offset="1">
              <el-tag type="success" disable-transitions size="small" v-if="ext.key">{{ ext.app_version ||
                eventForm.app_version }}
              </el-tag>
            </el-col>
            <el-col :span='2' class='align-center'>
              <i class='el-icon-plus add-icon' @click='addExtra' v-if='idx == eventForm.extra.length - 1'></i>
              <i class='el-icon-delete delete-icon' @click='deleteExtra(idx)' v-if='idx > 0'></i>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="示例图">
          <el-row>
            <el-col v-for="(pic, idx) of eventForm.picList" :span="6" class="image-col" :key="idx" style="relative">
              <el-image style="width: 120px; height: 120px; margin: 0 auto" :src="pic"
                :preview-src-list="eventForm.picList" fit="contain">
              </el-image>
              <i class="el-icon-circle-close delete-icon" @click="handleRemoveImage(idx)"></i>
            </el-col>
            <el-col :span="6" class="image-col">
              <el-upload class="thum-uploader" action="https://data.answeraiops.com/nfs/v1.0/file/upload"
                :show-file-list="false" :on-success="handleUploadSuccess">
                <i class="el-icon-plus thum-uploader-icon"></i>
              </el-upload>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="指定开发" prop="developed_by">
          <el-select v-model="eventForm.developed_by" clearable filterable>
            <el-option v-for="user of users" :key="user.realname" :label="user.realname" :value="user.realname">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-select v-model="selectedPlatforms" multiple clearable>
          <el-option v-for="platform of platforms" :key="platform.id" :label="platform.name" :value="platform.id">
          </el-option>
        </el-select>
        <el-button type="primary" @click="copyToOtherPlatform"
          :loading="copyBtnLoading"
          :disabled="selectedPlatforms.length == 0">复制到其他平台</el-button>
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="previewDialogVisible">
      <img width="100%" :src="previewImageUrl" alt="">
    </el-dialog>
  </div>
</template>
<script>

const eventStatusOptions = [
  { value: 0, label: '需求阶段', class: 'primary' },
  { value: 1, label: '已开发', class: 'primary' },
  { value: 2, label: '已测试', class: 'primary' },
  { value: 3, label: '正常上报', class: 'success' },
  { value: 4, label: '已禁用', class: 'info' },
  { value: 5, label: '修改待确认', class: 'warning' },
];

const emptyEvent = {
  name: '',
  event: '',
  app_version: '',
  url: '',
  tag: '',
  type: 1,
  status: 0,
  picList: [],
  pictures: '',
  disabled: false,
  extra: [
    { key: '', value: '', app_version: '' }
  ]
};

const eventFields = [
  'id', 'app_id', 'name', 'event', 'app_version', 'url', 'tag', 'type', 'properties', 'disabled',
  'status', 'developed_by', 'pictures'
];

export default {
  data() {
    return {
      copyBtnLoading: false,
      selectedPlatforms: [],
      platforms: [],
      app: '',
      page: 1,
      limit: 12,
      totalCount: 0,
      tableVisible: false,
      searchParams: {
        name: '',
        status: undefined,
        version: '',
        developed_by: '',
        created_by_me: false,
      },
      currentUser: '',
      dialogTitle: '',
      originEvents: [],
      events: [],
      tableData: [],
      typeOptions: [
        { label: '浏览', value: 1 },
        { label: '点击', value: 2 },
        { label: 'API', value: 3 },
      ],
      users: [],
      eventStatusOptions: eventStatusOptions,
      saveEventUrl: '/etp/v1.0/event/save',
      newEventDialogVisible: false,
      eventForm: JSON.parse(JSON.stringify(emptyEvent)),
      eventFormRules: {
        name: [
          { required: true, message: '请输入打点名称', trigger: 'blur' },
        ],
        event: [
          { required: true, message: '请选择Event', trigger: 'change' }
        ],
        app_version: [
          { required: true, message: '请输入app版本', trigger: 'change' }
        ],
        url: [
          { required: true, message: '请输入打点页面', trigger: 'change' }
        ],
        type: [
          { required: true, message: '请选择打点方式', trigger: 'change' }
        ]
      },
      previewDialogVisible: false,
      previewImageUrl: ''
    };
  },

  mounted() {
    this.search();
    this.getUsers();
    this.getUserInfo();
    this.getPlatforms();
  },
  computed: {
    eventStatusMap: function () {
      let m = {};
      eventStatusOptions.forEach((o) => m[o.value] = { label: o.label, class: o.class });
      return m;
    }
  },
  methods: {
    copyToOtherPlatform() {
      this.$refs['newEventForm'].validate(async (valid) => {

        if (!valid) {
          this.$notify({
            title: "警告",
            message: "请输入必填信息",
            type: "warning"
          });
          return;
        }

        this.copyBtnLoading = true;

        let data = JSON.parse(JSON.stringify(this.eventForm));

        let props = [];
        data.extra.forEach((e) => {

          let k = e.key.trim();
          let v = e.value.trim();

          if (k == '') {
            return;
          }

          props.push({ key: k, value: v });

        });

        delete data.extra;

        data['properties'] = props;
        data.app_id = this.$store.state.appId;
        data.disabled = false;
        data.pictures = data.picList.join(',');

        Object.keys(data).forEach(k => {
          if (eventFields.indexOf(k) == -1) {
            delete data[k];
          }
        });
        const url = '/etp/v1.0/event/copy';
        let rst = await this.$http.post(url, {
          event_info:data,
          to_app_ids:this.selectedPlatforms
        });
        if (rst.data.err_code == 0) {
          this.$notify({
            title: '提示',
            message: '复制成功',
            type: 'success'
          });
          this.selectedPlatforms = [];
        }else{
          this.$notify({
            title: '提示',
            message: '复制失败',
            type: 'error'
          });
        }

        this.copyBtnLoading = false;

      });
    },
    getPlatforms() {
      this.$http.get(`/etp/v1.0/app/list?system=${this.$route.params.system}&sort=asc`).then(rst => {
        this.platforms = rst.data.data?.filter(p => p.id != this.$store.state.appId);
      });
    },
    getUserInfo() {
      let info = JSON.parse(localStorage.getItem('userinfo'));
      this.currentUser = info.username;
    },
    async handleAdd() {
      this.dialogTitle = '新增事件';
      this.newEventDialogVisible = true;
      this.eventForm = emptyEvent;
    },

    addExtra() {
      this.eventForm.extra.push({ key: '', value: '', version: '' });
    },

    deleteExtra(idx) {
      this.eventForm.extra.splice(idx, 1);
    },

    handleClose() {
      this.newEventDialogVisible = false;
      this.selectedPlatforms = [];
    },

    submit() {

      this.$refs['newEventForm'].validate(async (valid) => {

        if (!valid) {
          this.$notify({
            title: "警告",
            message: "请输入必填信息",
            type: "warning"
          });
          return;
        }

        let data = JSON.parse(JSON.stringify(this.eventForm));

        let props = [];
        data.extra.forEach((e) => {

          let k = e.key.trim();
          let v = e.value.trim();

          if (k == '') {
            return;
          }

          props.push({ key: k, value: v });

        });

        delete data.extra;

        data['properties'] = props;
        data.app_id = this.$store.state.appId;
        data.disabled = false;
        data.pictures = data.picList.join(',');

        Object.keys(data).forEach(k => {
          if (eventFields.indexOf(k) == -1) {
            delete data[k];
          }
        });

        let rst = await this.$http.post(this.saveEventUrl, data);
        if (rst.data.err_code == 0) {
          this.$notify({
            title: '提示',
            message: '保存成功',
            type: 'success'
          });
          this.handleClose();
          this.getEvents();
        }

      });
    },
    handleDelete(row) {
      this.$confirm('确定删除埋点?')
        .then(async () => {
          let rst = await this.$http.post('/etp/v1.0/event/delete', { id: [row.id] });
          if (rst.data.err_code == 0) {
            this.$notify({
              title: '提示',
              message: '删除成功',
              type: 'success'
            });
            await this.getEvents();
          }
        })
        .catch(() => { });
    },

    handleEdit(row) {
      this.dialogTitle = '修改事件';
      row = JSON.parse(JSON.stringify(row));
      let props = row.properties;
      row.extra = props;

      if (row.extra.length == 0) {
        row.extra = [{ key: '', value: '', app_version: '' }];
      }

      this.eventForm = row;
      this.newEventDialogVisible = true;

    },

    handleDisable(row) {

      let t = row.disabled ? '启用' : '禁用';

      this.$confirm(`确认${t}${row.event}?`)
        .then(async () => {

          row.disabled = !row.disabled;
          Object.keys(row).forEach((k) => {
            if (eventFields.indexOf(k) == -1) {
              delete row[k];
            }
          });

          let rst = await this.$http.post(this.saveEventUrl, row);

          if (rst.data.err_code == 0) {
            this.$notify({
              title: '提示',
              message: '保存成功',
              type: 'success'
            });
            await this.getEvents();
          }

        })
        .catch(_ => {
        });

    },

    handleUploadSuccess(response, file, fileList) {
      let url = response.data.url.replace('http://43.128.97.186:80', 'https://data.answeraiops.com');
      this.eventForm.picList.push(url);
    },
    handleRemoveImage(idx) {
      this.eventForm.picList.splice(idx, 1);
    },
    changePage(val) {
      this.page = val;
      this.getEvents();
    },

    search() {
      this.tableData = [];
      this.getEvents();
    },
    async getUsers() {
      let url = `/ams/admin/list?offset=0&limit=250`;
      let rst = await this.$http.get(url);

      let users = rst.data.data;

      let appId = this.$store.state.appId;

      users = users.filter((user) => {
        for (let i = 0; i < user.roles.length; i++) {
          let role = user.roles[i];
          if (role.apps.indexOf(appId) > -1) {
            return true;
          }
          return false;
        }
      });

      this.users = users;

    },
    async getEvents() {

      let name = this.searchParams.name.trim();
      let { status, version, developed_by, created_by_me } = this.searchParams;

      this.tableVisible = false;
      let offset = (this.page - 1) * this.limit;

      let url = `/etp/v1.0/event/list?app_id=${this.$store.state.appId}&offset=${offset}&limit=${this.limit}`;
      if (name) {
        url += `&name=${name}`;
      }

      if (version) {
        url += `&version=${version}`;
      }

      if (developed_by) {
        url += `&developed_by=${developed_by}`;
      }

      if (created_by_me) {
        url += `&created_by=${this.currentUser}`;
      }

      if (status != undefined && status !== "") {
        url += `&status=${status}`;
      } else {
        url += `&status=-1`;
      }

      let rst = await this.$http.get(url);
      let events = rst.data.data;
      events.forEach((e) => {
        e.typeName = this.typeOptions[e.type - 1].label;
        // e.updated_at = e.updated_at.split('.')[0].replace('T', ' ');
        let vers = e.app_version.split(',');
        e.first_version = vers[vers.length - 1];
        e.last_version = vers[0];
        e.app_version = vers[0];
        e.picList = e.pictures.split(',').filter(x => x);

        e.update_date = e.updated_at.split('T')[0];
      });

      this.totalCount = rst.data.total;
      this.tableData = events;

      this.tableVisible = true;

    }
  }

};
</script>
<style lang="less" scoped>
.container {
  padding: 10px;
}

.align-center {
  text-align: center;
}

.text-small {
  font-size: 12px;
}

.thum-uploader {
  width: 120px;
  height: 120px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin: 0 auto;
}

.thum-uploader:hover {
  border-color: #409EFF;
}

.thum-uploader-icon {
  font-size: 24px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}

.image-col {
  padding: 5px;
  text-align: center;
  position: relative;
}

.delete-icon {
  position: absolute;
  z-index: 1000;
  font-size: 32px;
  right: 5px;
  top: 5px;
  color: #ccc;
}

.delete-icon:hover {
  cursor: pointer;
  color: #eee;
}
</style>
